/* eslint-disable */
import { FormEditFieldCreateDialogView, FormEditFieldDialogViewFactory, FormEditFieldUpdateDialogView, } from './form-utils';
import { ComponentFactoryResolver, ComponentRef, Injector, } from '@angular/core';
import { FormEditCreateUpdateReadonlyHtmlFieldDialogComponent } from '../../admin/form/form-edit/dialogs/fields/readonly/html-create-update/form-edit-create-update-readonly-html-field-dialog.component';
/* eslint-enable */

/**
 * ReadonlyHtml field implementation.
 */
export class FormEditReadonlyHtmlFieldDialogViewFactory implements FormEditFieldDialogViewFactory {

  constructor(private injector: Injector,
              private cfr: ComponentFactoryResolver) {
  }

  createCreateView(): ComponentRef<FormEditFieldCreateDialogView> {
    return this.createView();
  }

  createUpdateView(): ComponentRef<FormEditFieldUpdateDialogView> {
    return this.updateView();
  }

  private createView(): ComponentRef<FormEditCreateUpdateReadonlyHtmlFieldDialogComponent> {
    return this.cfr.resolveComponentFactory(FormEditCreateUpdateReadonlyHtmlFieldDialogComponent)
      .create(this.injector);
  }

  private updateView(): ComponentRef<FormEditCreateUpdateReadonlyHtmlFieldDialogComponent> {
    return this.cfr.resolveComponentFactory(FormEditCreateUpdateReadonlyHtmlFieldDialogComponent)
      .create(this.injector);
  }

}
